import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {StyledReportErrorBtn, StyledText} from './styled';

interface ReportErrorBtnProps {
	onClick: () => void;
	customText?: string;
	btnName?: 'incident' | 'credit' | 'bug';
}

const ReportErrorBtn: React.FC<ReportErrorBtnProps> = ({onClick, btnName, customText}) => {
	const [t] = useTranslation();

	const btnLabel = useMemo(() => {
		switch (btnName) {
		case 'incident':
			return t('Report incident');
		case 'credit':
			return t('Crediting form');
		case 'bug':
			return t('Report bug');
		default:
			return t('Report incident');
		}
	}, [btnName, t]);

	return (
		<StyledReportErrorBtn
			onClick={onClick}
			compact
		>
			<StyledText>{customText ? customText : btnLabel}</StyledText>
		</StyledReportErrorBtn>
	);
};

export default ReportErrorBtn;

